import React from "react";
import OverviewImg from "../../../images/Overview.png";
import caretImg from "../../../images/caret.png";
import upArrow from "../../../images/up-arrow.png";
import downArrow from "../../../images/down-arrow.png";
import merchVolGraph from "../../../images/merch-vol-graph.png";
import { DateRangePicker } from "rsuite";
import startOfDay from "date-fns/startOfDay";
import endOfDay from "date-fns/endOfDay";
import addDays from "date-fns/addDays";
import subDays from "date-fns/subDays";
import { subYears, startOfYear, endOfYear, subMonths } from "date-fns";
import SelectDropDown from "./drop-down";
import { getAnalyticsData } from "../../api";

class AnalyticsOverview extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            calenderValue: [],
            totalSales: 0,
            updownPerc: 0,
            dropUserText: "",
            user: "",
            timePeriodValue: "Last_7_Days",
            total_transactions: 0,
            transaction_amount: 0,
        };
        this.element = React.createRef();
    }

    componentDidMount = () => {
        let date = new Date();
        let params = {
            firstDate: subDays(date, 6).toLocaleDateString("en-US"),
            lastDate: date.toLocaleDateString("en-US"),
            user: this.state.user,
        };
        this.setState({ calenderValue: [params.firstDate, params.lastDate] });
        getAnalyticsData(params)
            .then((res) => {
                this.setState({
                    totalSales: res.totalSales,
                    perc: res.perc,
                    total_transactions: res.transactions_count,
                    transaction_amount: res.transactions_amount,
                });
            })
            .catch((err) => {});
    };

    handleProcessingAppDateChange(dates) {
        let params = {
            firstDate: dates[0].toLocaleDateString("en-US"),
            lastDate: dates[1].toLocaleDateString("en-US"),
            user: this.state.user,
        };

        this.setState({
            calenderValue: [
                dates[0].toLocaleDateString("en-US"),
                dates[1].toLocaleDateString("en-US"),
            ],
            timePeriodValue: "Custom_date",
        });
        getAnalyticsData(params)
            .then((res) => {
                this.setState({
                    totalSales: res.totalSales,
                    perc: res.perc,
                    total_transactions: res.transactions_count,
                    transaction_amount: res.transactions_amount,
                });
            })
            .catch((err) => {});
    }

    handlePeriodChange = (e) => {
        e.persist();
        var date = new Date();
        let params = {};
        this.setState({
            timePeriodValue: e.target.value,
            calenderValue: [startOfDay(new Date()), endOfDay(new Date())],
        });

        if (e.target.value === "Last_7_Days") {
            params = {
                firstDate: subDays(date, 6).toLocaleDateString("en-US"),
                lastDate: date.toLocaleDateString("en-US"),
                user: this.state.user,
            };
        } else if (e.target.value === "Current_month") {
            params = {
                firstDate: new Date(
                    date.getFullYear(),
                    date.getMonth(),
                    1,
                ).toLocaleDateString("en-US"),
                lastDate: new Date().toLocaleDateString("en-US"),
                user: this.state.user,
            };
        } else if (e.target.value === "Current_Year") {
            params = {
                firstDate: startOfYear(date).toLocaleDateString("en-US"),
                lastDate: date.toLocaleDateString("en-US"),
                user: this.state.user,
            };
        } else if (e.target.value === "Last_month") {
            params = {
                firstDate: new Date(
                    date.getFullYear(),
                    date.getMonth() - 1,
                    1,
                ).toLocaleDateString("en-US"),
                lastDate: new Date(
                    date.getFullYear(),
                    date.getMonth(),
                    0,
                ).toLocaleDateString("en-US"),
                user: this.state.user,
            };
        } else if (e.target.value === "Last_3_Months") {
            params = {
                firstDate: subMonths(date, 3).toLocaleDateString("en-US"),
                lastDate: date.toLocaleDateString("en-US"),
                user: this.state.user,
            };
        } else if (e.target.value === "Last_6_Months") {
            params = {
                firstDate: subMonths(date, 6).toLocaleDateString("en-US"),
                lastDate: date.toLocaleDateString("en-US"),
                user: this.state.user,
            };
        } else if (e.target.value === "Previous_Year") {
            params = {
                firstDate: startOfYear(subYears(date, 1)).toLocaleDateString(
                    "en-US",
                ),
                lastDate: endOfYear(subYears(date, 1)).toLocaleDateString(
                    "en-US",
                ),
                user: this.state.user,
            };
        } else if (e.target.value === "All") {
            params = {
                firstDate: new Date("01/01/2000").toLocaleDateString("en-US"),
                lastDate: date.toLocaleDateString("en-US"),
                user: this.state.user,
            };
        } else if (e.target.value === "Custom_date") {
            this.element.current.open();
            return;
        }

        this.setState({ calenderValue: [params.firstDate, params.lastDate] });
        getAnalyticsData(params)
            .then((res) => {
                this.setState({
                    totalSales: res.totalSales,
                    perc: res.perc,
                    total_transactions: res.transactions_count,
                    transaction_amount: res.transactions_amount,
                });
            })
            .catch((err) => {});
    };
    handelUserChange = (e) => {
        let value = e.value;
        if (value.split("-")[0] === "org") {
            this.setState({
                dropUserText: "Org",
                user: value,
            });
        } else {
            this.setState({
                dropUserText: "User",
                user: value,
            });
        }

        this.props.updateDropUser(value);

        let params = {
            firstDate: this.state.calenderValue[0],
            lastDate: this.state.calenderValue[1],
            user: value,
        };

        getAnalyticsData(params)
            .then((res) => {
                this.setState({
                    totalSales: res.totalSales,
                    perc: res.perc,
                    total_transactions: res.transactions_count,
                    transaction_amount: res.transactions_amount,
                });
            })
            .catch((err) => {});
    };

    render() {
        const timePeriod = [
            "Last_7_Days",
            "Current_month",
            "Current_Year",
            "Last_month",
            "Last_3_Months",
            "Last_6_Months",
            "Previous_Year",
            "All",
            "Custom_date",
        ];
        const { afterToday } = DateRangePicker;
        return (
            <div className="app">
                <div className="shadow-card">
                    <div className="row app-process-metric app-process-row">
                        <div className="col-md-6 col">
                            <img style={{ width: "auto" }} src={OverviewImg} />
                            <h4>Analytics overview</h4>
                        </div>
                        <div className="col-md-6 col">
                            <div className="d-flex">
                                <div className="d-flex align-items-center datePickerParentClass">
                                    <div className="myDatePicker datepicker-range-app data-picker-metrics-area">
                                        <DateRangePicker
                                            ref={this.element}
                                            onChange={(value) => {
                                                this.handleProcessingAppDateChange(
                                                    value,
                                                );
                                            }}
                                            onOk={(value) => {
                                                this.handleProcessingAppDateChange(
                                                    value,
                                                );
                                            }}
                                            appearance="subtle"
                                            placeholder=""
                                            style={{ width: 28 }}
                                            disabledDate={afterToday()}
                                            cleanable={false}
                                            ranges={[
                                                {
                                                    label: "Yesterday",
                                                    value: [
                                                        addDays(new Date(), -1),
                                                        addDays(new Date(), -1),
                                                    ],
                                                },
                                                {
                                                    label: "Today",
                                                    value: [
                                                        new Date(),
                                                        new Date(),
                                                    ],
                                                },
                                                {
                                                    label: "Last 7 days",
                                                    value: [
                                                        subDays(new Date(), 6),
                                                        new Date(),
                                                    ],
                                                },
                                            ]}
                                            placement="rightStart"
                                        />
                                    </div>

                                    <div className="period-btn">
                                        <span>Period</span>
                                        <select
                                            style={{
                                                backgroundImage: `url(${caretImg})`,
                                            }}
                                            onChange={(e) =>
                                                this.handlePeriodChange(e)
                                            }
                                            name="periodoptn"
                                        >
                                            {timePeriod.map((item, index) => (
                                                <option
                                                    value={item}
                                                    key={index}
                                                >
                                                    {item.replace(/_/g, " ")}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                </div>

                                {this.props.user.organization_id > 1 &&
                                this.props.user.role === "agent" ? null : (
                                    <div className="d-flex align-items-center analytics-filtering">
                                        <span>{this.state.dropUserText}</span>
                                        <SelectDropDown
                                            options={this.props.dropDownUsers}
                                            name="periodoptn"
                                            placeholder="Choose To Filter"
                                            value=""
                                            handleChange={(evt) =>
                                                this.handelUserChange(evt)
                                            }
                                        />
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                    <hr />

                    <div className="row analytics-overview-row2">
                        <div className="col-md-6">
                            <div className="row">
                                <div className="col-md-6">
                                    <div className="analyticsOverview">
                                        <p>Total volume</p>
                                        <h3 className="analytics_heading">
                                            {this.props.user.organization_id ==
                                            1 ? (
                                                <>${this.state.totalSales}</>
                                            ) : (
                                                <>Coming Soon</>
                                            )}
                                        </h3>
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="analyticsOverview">
                                        <p>Total transactions</p>
                                        <h3
                                            className="analytics_heading"
                                            style={{ fontSize: 21 + "px" }}
                                        >
                                            {this.props.user.organization_id ==
                                            1 ? (
                                                <>
                                                    {
                                                        this.state
                                                            .total_transactions
                                                    }
                                                </>
                                            ) : (
                                                <>Coming Soon</>
                                            )}
                                        </h3>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-6">
                            <div className="row">
                                <div className="col-md-9">
                                    <div className="analyticsOverview avg-merchant-volume">
                                        <p>Total merchant volume</p>
                                        <div className="d-flex alignItemEnd">
                                            <div className="media-body1">
                                                <h3
                                                    className="analytics_heading"
                                                    style={{
                                                        fontSize: 21 + "px",
                                                    }}
                                                >
                                                    {this.props.user
                                                        .organization_id ==
                                                    1 ? (
                                                        <>
                                                            $
                                                            {
                                                                this.state
                                                                    .transaction_amount
                                                            }
                                                        </>
                                                    ) : (
                                                        <>Coming Soon</>
                                                    )}
                                                </h3>
                                            </div>
                                            <img
                                                style={{ width: "auto" }}
                                                src={merchVolGraph}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default AnalyticsOverview;
